import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BsaSteps from '../steps';
import Icon from '../icon';
import './style';

const { Step } = BsaSteps;

const propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    status: PropTypes.string,
  })).isRequired,
  className: PropTypes.string,
  currentIndex: PropTypes.number,
  currentStatus: PropTypes.string,
  size: PropTypes.string,
};

const defaultProps = {
  currentIndex: null,
  currentStatus: null,
  className: null,
  size: 'default',
};

function getContent(step, index) {
  if (step.status === 'success' || step.status === 'finish') {
    return <Icon type="check" />;
  } else if (step.status === 'error') {
    return <Icon type="close" />;
  }

  return index + 1;
}

function getIcon(step, index, arr, size) {
  return (
    <Fragment>
      <div className={classNames('bsa-pin-steps__step-counter', size ? `bsa-pin-steps__step-counter--size-${size}` : null)}>
        {getContent(step, index)}
        {index === arr.length - 1 ? null : <div className={
          classNames(
            'bsa-pin-steps__tail-end',
            size ? `bsa-pin-steps__tail-end--size-${size}` : null,
            step.status ? `bsa-pin-steps__tail-end--status-${step.status}` : null,
          )}
        />}
        {index === 0 ? null : <div className={
          classNames(
            'bsa-pin-steps__tail-lead',
            size ? `bsa-pin-steps__tail-lead--size-${size}` : null,
            step.status ? `bsa-pin-steps__tail-lead--status-${step.status}` : null,
          )}
        />}
      </div>
      <div className={classNames('bsa-pin-steps__step-title', size ? `bsa-pin-steps__step-title--size-${size}` : null)}>
        {step.title}
      </div>
    </Fragment>
  );
}

function renderStep(step, index, arr) {
  const className = classNames(
    'bsa-pin-steps__step',
    step.status ? `bsa-pin-steps__step--status-${step.status}` : null,
    step.size ? `bsa-pin-steps__step--size-${step.size}` : null,
  );

  return (
    <Step
      className={className}
      key={step.title}
      icon={getIcon(step, index, arr, step.size)}
      title={step.title}
    />
  );
}

function generateSteps(steps, currentIndex, currentStatus, size) {
  if (currentIndex === null) return steps.map(step => Object.assign({ size }, step));
  return steps.map((step, index) => {
    if (index < currentIndex) {
      return Object.assign({
        status: 'finish',
        size,
      }, step);
    } else if (index === currentIndex) {
      return Object.assign({
        status: currentStatus || 'process',
        size,
      }, step);
    }

    return Object.assign({ size }, step);
  });
}

function PinSteps({
  steps, className, currentIndex, currentStatus, size,
}) {
  const generatedSteps = generateSteps(steps, currentIndex, currentStatus, size);
  return (
    <BsaSteps
      current={currentIndex}
      status={currentStatus}
      className={classNames('bsa-pin-steps', className)}
    >
      {generatedSteps.map(renderStep)}
    </BsaSteps>
  );
}

PinSteps.propTypes = propTypes;
PinSteps.defaultProps = defaultProps;

export default PinSteps;
